<template lang='pug'>
.base(id="itemsWrapper")
  CursorCustom(:theme="theme")
  BaseView(
    :theme="theme"
    :appear="appear"
    :animation="animation"
    )
    PageGallery
      GalleryCarousel(:items="items")
      .fullview
      .fullview__item(
          v-for="item in items"
        )
      button(class="fullview__close zoom-out" aria-label="Close preview")
</template>

<script>
import CursorCustom from "../../components/elements/Cursor/index";
import BaseView from "../../views/BaseView/index";
import PageGallery from "../../components/blocks/PageGallery/index";
import GalleryCarousel from "../../components/blocks/GalleryCarousel/index";
export default {
  name: "Gallery",
  data() {
    return {
      pageProps: {
        title: "Gallery",
        link: {
          name: "test",
          route: "/"
        }
      },
      items: [
        {
          preview: require("./items/01.webp"),
          detail: require("./items/01.webp"),
          link: "https://commons.wikimedia.org/wiki/File:Chrysler_Biulding_NYC-20090519-RM-094845.jpg"
        },
        {
          preview: require("./items/02.webp"),
          detail: require("./items/02.webp"),
          link: "https://commons.wikimedia.org/wiki/File:Chrysler_Building_eagle.jpg"
        },
        {
          preview: require("./items/03.webp"),
          detail: require("./items/03.webp"),
          link: "https://commons.wikimedia.org/wiki/File:Chrysler_Building_Eagles_left.jpg"
        },
        {
          preview: require("./items/04.webp"),
          detail: require("./items/04.webp"),
          link: "https://commons.wikimedia.org/wiki/File:Chrysler_Building_1e_(6218238725).jpg"
        },
        {
          preview: require("./items/05.webp"),
          detail: require("./items/05.webp"),
          link: "https://commons.wikimedia.org/wiki/File:Chrysler_building_(15746380543).jpg"
        },
        {
          preview: require("./items/06.webp"),
          detail: require("./items/06.webp"),
          link: "https://commons.wikimedia.org/wiki/File:Chrysler_Building_flagpole_detail.jpg"
        },
        {
          preview: require("./items/07.webp"),
          detail: require("./items/07.webp"),
          link: "https://commons.wikimedia.org/wiki/File:NYC_-_Chrysler_Building_-_0726.jpg"
        },
        {
          preview: require("./items/08.webp"),
          detail: require("./items/08.webp"),
          link: "https://commons.wikimedia.org/wiki/File:Chrysler_Building_from_East_River_2_(6215708346).jpg"
        },
        {
          preview: require("./items/09.webp"),
          detail: require("./items/09.webp"),
          link: "https://commons.wikimedia.org/wiki/File:Chrysler_Central_Elevator_2019-10-03_20-18.jpg"
        },
        {
          preview: require("./items/10.webp"),
          detail: require("./items/10.webp"),
          link: "https://commons.wikimedia.org/wiki/File:Chrysler_building_hall.jpg"
        }
      ],
      scrollbar: true,
      type: "full",
      theme: "light",
      appear: "normal",
      animation: "clear"
    };
  },
  methods: {
    clearCursor() {
      document.querySelector(".circle-cursor--outer").remove();
      document.querySelector(".circle-cursor--inner").remove();
    }
  },
  beforeDestroy() {
    document.querySelector(".fullview__close").remove();
    document.querySelector("canvas").remove();
    this.clearCursor();
  },
  components: {
    BaseView,
    PageGallery,
    GalleryCarousel,
    CursorCustom
  }
};
</script>

<style lang="sass" scoped>
@import "src/sass/general/variables"
@import "src/sass/general/page"
.fullview__close
  width: 100vw
  height: 100vh
  top: 0
  left: 0
  position: fixed
  transform: none!important
  &:before, &:after
    display: none
.base
  background: $light
</style>
